export enum LegalStructureEnum {
  NOT_INCORPORATED = "NOT_INCORPORATED",
  SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",
  PARTNERSHIP = "PARTNERSHIP",
  S_CORPORATION = "S_CORPORATION",
  C_CORPORATION = "C_CORPORATION",
  LLC = "LLC",
}
